import React, { useState } from 'react';
import styles from './DiscourseControls.module.scss';
import AddButton from '../../../../Components/Button/AddButton';
import MedicalReportDetailModal from '../../../../Components/MedicalReport/MedicalReportDetailModal';
import ElectronicPrescriptionModal from '../../../Prescription/Components/ElectronicPrescriptionModal';
import { useDiscourseContext } from '../../Services/DiscourseContext';

interface Props {
	allowElectronicPrescription?: boolean;
	allowMedicalReport?: boolean;
	patientId: string;
	virtualPatientId: string;
	caseId?: string;
	workplaceId: string;
	onNewDiscourseRecord: () => void;
}

const DiscourseControls: React.FC<Props> = ({
	allowElectronicPrescription = true,
	allowMedicalReport = true,
	virtualPatientId,
	patientId,
	caseId,
	workplaceId,
	onNewDiscourseRecord,
}) => {
	const { handleRefreshAttachments } = useDiscourseContext();

	const [
		isElectronicPrescriptionCreateOpen,
		setIsElectronicPrescriptionCreateOpen,
	] = useState(false);
	const [isMedicalReportCreateOpen, setIsMedicalReportCreateOpen] =
		useState(false);

	return (
		<>
			<div className={styles.wrapper}>
				<AddButton
					title='component.discourse.newRecord'
					onClick={onNewDiscourseRecord}
				/>
				{allowElectronicPrescription && (
					<AddButton
						title='base.issueEprescription'
						onClick={() => setIsElectronicPrescriptionCreateOpen(true)}
					/>
				)}
				{allowMedicalReport && (
					<AddButton
						title='base.shared.createMedicalReport'
						onClick={() => setIsMedicalReportCreateOpen(true)}
					/>
				)}
			</div>
			{isMedicalReportCreateOpen && (
				<MedicalReportDetailModal
					opened
					onClose={() => setIsMedicalReportCreateOpen(false)}
					onMedicalReportCreate={handleRefreshAttachments}
					workplaceId={workplaceId}
					patientId={virtualPatientId}
					caseId={caseId}
					attachToDiscourse
					createDekurz={false}
				/>
			)}
			{isElectronicPrescriptionCreateOpen && (
				<ElectronicPrescriptionModal
					opened
					onClose={() => setIsElectronicPrescriptionCreateOpen(false)}
					onCreate={handleRefreshAttachments}
					patientId={patientId}
					attachToDiscourse
					createDekurz={false}
				/>
			)}
		</>
	);
};

export default DiscourseControls;
